import React, { useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { Paper, Box, Typography, makeStyles, Grid } from '@material-ui/core';
import KenInput from '../../components/KenInputField';
import KenButton from '../../components/KenButton';
import { otpGenerator } from '../../utils/Otp';
import clsx from 'clsx';
import { getContactInfo } from '../../utils/ApiService';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import '../../themes/styles.scss';
import configContext from '../../utils/config';
import Validation from '../../utils/ValidationMessages';
import KenSnackBar from '../../components/KenSnackbar';
import countryCodes from '../../json/countryISDCode.json';
import KenInputMobile from '../../components/KenInputMobile';
import {
  sendOtpTo,
  isOtpValid,
  isUserAlreadyRegistered,
  getContactId,
  storeInfo,
} from './helper';
import { GLOBAL } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import { routes } from '../../utils/urls';
import { getContactByPhone } from '../../utils/ApiService';

const useStyles = makeStyles((theme) => ({
  paper: {},
  hide: {
    display: 'none',
  },
  reSend: {
    cursor: 'pointer',
    float: 'right',
  },
  Heading: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: 24,
  },
  change: {
    cursor: 'pointer',
  },
  registerLabel: {
    textAlign: 'center',
    marginBottom: '10px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 12,
  },
  applyLabel: {
    fontSize: 14,
  },
}));

export default withRouter(function ExistingInfo(props) {
  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
});

const ExistingForm = (props) => {
  const { t } = useTranslation();
  const {
    toggle,
    values,
    touched,
    errors,
    handleChange,
    setFieldTouched,
    handleSubmit,
    setFieldValue,
  } = props;
  const { config } = React.useContext(configContext);

  let phone = '';
  phone = values.countryCode + '' + values.phone;
  if (phone) {
    phone = phone.substring(1);
  }
  const options = countryCodes.codes;
  const history = useHistory();
  const classes = useStyles();
  const [otp, setOtp] = React.useState();
  const [showOtpEnter, setShowOtpEnter] = React.useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === GLOBAL.REASONS.CLICKAWAY) return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  React.useEffect(() => {
    if (otp) {
      alert(`${t('snackbarMessages:noteOtp')} ${otp}`);
    }
  }, [otp]);

  const change = (name, e, index) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  const getAndStoreAndProcced = async (phoneNumber) => {
    getContactByPhone(phoneNumber).then((res) => {
      storeInfo(res.data[0], phoneNumber);
      history.push({
        pathname: routes.draft,
        state: {
          userDetails: res.data[0],
          ParentId:  res.data[0].Id,
          Email:  res.data[0].hed__AlternateEmail__c,
        },
      });
    });
  };

  values.handleLogin = () => {
    if (config.otpTo.toLocaleLowerCase() === GLOBAL.OTP.ON_SCREEN) {
      if (otp === values.userOTP) {
        getAndStoreAndProcced(phone);
      } else {
        handleSnackbarOpen('error', t('validations:otp'));
        setShowOtpEnter(true);
      }
    } else {
      isOtpValid(values.email, values.phone, config.otpTo, values.userOTP).then(
        (res) => {
          if (res.status) {
            getAndStoreAndProcced(phone);
          } else {
            handleSnackbarOpen('error', t('validations:otp'));
            setShowOtpEnter(true);
          }
        }
      );
    }
  };

  const handleOtp = async () => {
    const otpto = config.otpTo.toLocaleLowerCase();
    if (values.phone.length === 10) {
      const registeredUser = await isUserAlreadyRegistered(phone);
      if (registeredUser) {
        if (otpto === GLOBAL.OTP.ON_SCREEN) {
          setShowOtpEnter(true);
          setOtp(otpGenerator());
        } else {
          sendOtpTo(values.email, values.phone, otpto)
            .then((res) => {
              if (res.status === GLOBAL.RESPONSE_STATUS.SUCESS) {
                //In response we get "sucess", ignore spelling
                handleSnackbarOpen('success', t('validations:success_otp'));
                setShowOtpEnter(true);
              } else {
                handleSnackbarOpen('error', t('validations:fail_otp'));
              }
            })
            .catch((err) => {
              handleSnackbarOpen('error', t('validations:otp'));
            });
        }
      } else {
        handleSnackbarOpen('error', t('validations:mobile'));
      }
    } else {
      handleSnackbarOpen('error', t('validations:mobile'));
    }
  };

  return (
    <>
      <form>
        <Paper className={classes.paper} elevation={0}>
          <Box textAlign='center'>
            <Box pt={1}>
              <Typography variant='body2' className={classes.registerLabel}>
                <span>{t('titles:signIn_heading')}</span>
              </Typography>
            </Box>
            <Box pt={1}>
              <div>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <KenInputMobile
                      required
                      label={t('labels:mobile')}
                      inputName='phone'
                      startAdornment
                      onchangeInput={change.bind(null, 'phone')}
                      inputvalue={values.phone}
                      errors={errors.phone}
                      touched={touched.phone}
                      optionalLabel={false}
                      options={options}
                      selectName='countryCode'
                      countrycodeValue={values.countryCode}
                      setFieldValue={setFieldValue}
                      onChangeSelect={change.bind(null, 'countryCode')}
                      defaultCountryCode={GLOBAL.COUNTRY_CODES.DEFAULT}
                    />
                  </Grid>
                </Grid>
              </div>
            </Box>

            <Box
              className={clsx({
                [classes.hide]: showOtpEnter,
              })}
              pt={1}
              display='flex'
              alignItems='center'
              justifyContent='flex-end'
            >
              <KenButton
                variant='secondary'
                onClick={() => {
                  handleOtp();
                }}
              >
                {t('buttons:getOtp')}
              </KenButton>
            </Box>

            <div className={clsx({ [classes.hide]: !showOtpEnter })}>
              <Box pt={1}>
                <Typography
                  color='primary'
                  className={classes.reSend}
                  onClick={() => {
                    handleOtp();
                  }}
                >
                  {t('buttons:resendOtp')}
                </Typography>
                <KenInput
                  required
                  label={t('labels:enterOtp')}
                  name='userOTP'
                  onChange={change.bind(null, 'userOTP')}
                  value={values.userOTP}
                  errors={errors.userOTP}
                  touched={touched.userOTP}
                />
              </Box>

              <div>
                <Box pt={1} display='flex' justifyContent='flex-end'>
                  <KenButton variant='primary' onClick={handleSubmit}>
                    {t('buttons:go')}
                  </KenButton>
                </Box>
              </div>
              <div></div>
            </div>
          </Box>

          <Box pt={1} display='flex' justifyContent='center'>
            <Typography
              variant='body2'
              className={classes.change}
              onClick={toggle}
            >
              {t('titles:signIn_footer')}
            </Typography>
          </Box>
        </Paper>
      </form>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={2000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position='Bottom-Right'
      />
    </>
  );
};

const FormikHoc = (props) => {
  const { t } = useTranslation();
  const ExistingFormik = withFormik({
    mapPropsToValues: () => ({
      phone: '',
      countrycode: '',
      userOTP: '',
    }),

    validationSchema: Yup.object({
      phone: Yup.string()
        .required()
        .matches(GLOBAL.REGEX.PHONE_NUMBER, t('validations:phone_invalid'))
        .test('len', `${Validation.phone.digits}`, (val) => {
          if (val) {
            return val.toString().length === 10;
          }
        }),
    }),

    handleSubmit: (values) => {
      values.handleLogin();
      console.log(values,"values")
    },

    displayName: 'ExistingInformation',
  })(ExistingForm);

  return <ExistingFormik {...props} />;
};